import { render, staticRenderFns } from "./PrettyAddress.vue?vue&type=template&id=cfece67c&scoped=true&"
import script from "./PrettyAddress.vue?vue&type=script&lang=js&"
export * from "./PrettyAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfece67c",
  null
  
)

export default component.exports